import React from 'react';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet'
import { ThemedText, ThemedView } from "@app/theme";
import Button from "@sharedComponents/Button/Button";
import LottieView from "lottie-react-native";
import { getNextRoute } from '../../../../../src/navigationApp/navigationUtil';
import ROUTE from '@app/navigationApp/routes';
import { CONTEXT } from '@app/configs/constants';
import { Platform } from 'react-native';

interface SuccessCardProps {
    setShowSuccessCard: (show: boolean) => void;
    colors: any;
    nextStepId: string;
    navigation: any;
    successLottie: any;
    stepStatusMap?: any;
    applicationState?: any;
    contextfromApi?: string;
    setManualCTAClicked?: (manualCTAClicked: boolean) => void;
}

export const SuccessCard: React.FC<SuccessCardProps> = ({
                                                            setShowSuccessCard,
                                                            colors,
                                                            nextStepId,
                                                            navigation,
                                                            successLottie,
  stepStatusMap,
  applicationState,
  contextfromApi,
                                                          setManualCTAClicked
                                                        }) => {
    return (
        <BottomSheetContainer
            isVisible={true}
            close={() => {
                setShowSuccessCard(false)
            }}
            closeOnBackdropPress={true}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
        >
            <ThemedView alignItems={"center"} padding={"lg"}>
                <LottieView source={successLottie} autoPlay loop style={{ width: 70, height: 70}}/>
                <ThemedText mt={"lg"} variant={"h5s"} mb={"sm"}>
                    Selfie uploaded successfully
                </ThemedText>
                <ThemedText variant={"b3r"} textAlign={"center"} mt={"sm"} mb={"2xl"}>
                    You will be redirected to next step in few seconds
                </ThemedText>

                <Button
                    label="Continue"
                    type="OUTLINED"
                    size='MD'
                    disabled={false}
                    handlePress={() => {
                        setManualCTAClicked && setManualCTAClicked(true)
                        setShowSuccessCard(false)
                        if (contextfromApi === CONTEXT.PARTNER.toLowerCase()) {
                            navigation.navigate(ROUTE.MFD_SHARE_LINK_END_JOURNEY);
                        } else {
                            const nextRoute = getNextRoute(nextStepId, applicationState, stepStatusMap);
                            if (Platform.OS === 'web') {
                                navigation.navigate(nextRoute as any, {
                                    stepId: nextStepId,
                                    stepStatusMap: stepStatusMap,
                                    applicationState: applicationState
                                });
                            } else {
                                navigation.reset({
                                    index: 0,
                                    routes: [ {name : "HOME"} ,{ name: 'KYC_STEPPER' }, {
                                        name: nextRoute, params: {
                                            stepId: nextStepId,
                                            stepStatusMap: stepStatusMap,
                                            applicationState: applicationState
                                        }
                                    }]
                                })
                            }

                        }
                    }}
                    bg={colors['bg-action-primary']}
                    textColor={colors['text-primary']}
                />
            </ThemedView>
        </BottomSheetContainer>
    );
};